import React from "react"

import { isNotUndefinedOrNull } from "@/shared/FunctionCore";
import "@/app/pages/contactProfile/styles/ContactProfileRelatedIndustriesStyles.scss";

const ContactProfileRelatedIndustries = ({ relatedIndustries }): JSX.Element => {

	const renderIndustries = () => {
		if (isNotUndefinedOrNull(relatedIndustries)) {
			const industries = Object.keys(relatedIndustries)

			return industries.map((industry, i) => (
					<a
						className="link-with-underline"
						href={`contact-industry-search.${relatedIndustries[industry]}.html`}
						key={`${i}-${industry}`}
					>
						{industry}
					</a>
				)
			)
		}
	}

	return (
		<div className="browse-component contact-related-industries browse-block">
			<div className="container box-shadow-component contact-component-wrapper mobile-margin-lr">
				<div className="row">
					<h3 className="col-xs-12 component-title">
						Find Contacts in Related Industries
					</h3>
				</div>

				<hr className="title-bottom-line ml-minus-1" />
				<div className="row grid-wrap">
					<div className="col-xs-12 grid">
						{renderIndustries()}
					</div>
				</div>
			</div>

			<p>
				*Contacts and Principals counts are estimates and may differ from the actual number of contacts available in D&B Hoovers.
			</p>

		</div>
	)
};

export default ContactProfileRelatedIndustries;
